import { render, staticRenderFns } from "./navCom.vue?vue&type=template&id=9170ef5e&scoped=true&"
import script from "./navCom.vue?vue&type=script&lang=js&"
export * from "./navCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9170ef5e",
  null
  
)

export default component.exports